if (!customElements.get('vertical-marquee')) {
    class MarqueeVertical extends HTMLElement {
      constructor() {
        super();
        this.content = document.createElement('div');
        this.content.classList.add('marquee-content');
        this.isPaused = false;
        this.currentY = 0;
      }

      connectedCallback() {
        Array.from(this.children).forEach(child => this.content.appendChild(child));
        this.appendChild(this.content);

        this.itemHeight = this.querySelector('.marquee-item').offsetHeight;

        this.startScrolling();

        this.addEventListener('mouseover', () => (this.isPaused = true));
        this.addEventListener('mouseleave', () => (this.isPaused = false));
        
        document.addEventListener('click', e => {
          if (!e.target.closest('[data-action="pause-marquee"]')) return;
          e.target.closest('[data-action="pause-marquee"]').classList.toggle('paused', !this.isPaused);
          this.isPaused = !this.isPaused;
        });
        
        window.addEventListener('resize', () => {
          this.itemHeight = this.querySelector('.marquee-item').offsetHeight;
        });
      }

      startScrolling() {
        const scroll = () => {
          if (!this.isPaused) {
            const firstItem = this.content.children[0];
            this.currentY += this.itemHeight;
            firstItem.classList.add('faded-out');
            this.content.style.transform = `translateY(-${this.currentY}px)`;

            setTimeout(() => {
              this.content.appendChild(firstItem);
              firstItem.classList.remove('faded-out');
              this.currentY -= this.itemHeight; // Reset scroll position
              this.content.style.transition = 'none'; // Temporarily disable transition
              this.content.style.transform = `translateY(-${this.currentY}px)`;
              setTimeout(() => (this.content.style.transition = 'transform 0.25s linear'), 25);
            }, 250);
          }
          setTimeout(scroll, 750);
        };

        scroll();
      }
    }
    customElements.define('vertical-marquee', MarqueeVertical);
  }
